export default "__VITE_ASSET__BLMY1G71__"